import styled from 'styled-components'
import { themeGet } from 'styled-system'

import { Flex } from 'landing/kit'

export const Card = styled(Flex)`
  background: linear-gradient(86.46deg, #9C62FF 4.47%, #286EFA 99.49%);
  border-radius: 32px;
  padding: 50px 20px 20px 20px;
  margin-top: 50px;
  margin-bottom: -100px;

  @media screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 64px 90px;
    margin-top: 58px;
  }
`
